import TrophyBold from "../../../assets/icons/TrophyBold";

const PlaceholderImage = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} className="flex aspect-square items-center justify-center rounded-xl bg-foreground-lighter/10">
      <TrophyBold className="w-3/4" />
    </div>
  );
};

export default PlaceholderImage;
